<template>
  <div class="app-container">
    <div v-if="key == '/space/index'">
      <div class="screen">
        <el-form
          label-width="200px"
          :inline="true"
          :model="screen"
          class="form-inline"
          label-position="left"
        >
          <el-form-item label="选择园区">
            <el-select
              filterable
              v-model="screen.park_id"
              placeholder="请选择园区"
              :disabled="userInfo.park_id != 0"
              @change="ChangePark"
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                :label="item.name"
                :value="item.id"
                v-for="(item, index) in parkList"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="楼栋名称">
            <el-input
              v-model="screen.name"
              placeholder="楼栋名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="搜索" class="searchs">
            <el-button
              size="medium"
              type="primary"
              @click="(page = 1), fetchData()"
              >查询</el-button
            >
            <el-button size="medium" type="primary" plain @click="chongZhi()"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <el-button
        type="primary"
        @click="addSpace()"
        style="margin-bottom: 5px"
        v-if="roles.includes('/space/add')"
        >添加</el-button
      >
      <el-button
        type="info"
        @click="downloadFile()"
        style="margin-bottom: 5px"
        v-if="roles.includes('/space/template')"
        >下载模板</el-button
      >
      <el-button
        type="success"
        @click="leadIn()"
        style="margin-bottom: 5px"
        v-if="roles.includes('/space/import')"
        >导入</el-button
      >
      <el-button
        type="warning"
        @click="derive()"
        style="margin-bottom: 5px"
        v-if="roles.includes('/space/export')"
        >导出</el-button
      >
      <el-table
        max-height="700"  v-loading="listLoading" 
        :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
        :data="list"
        element-loading-text="Loading"
        fit
        highlight-current-row
        stripe
        class="table-box"
        tooltip-effect="dark"
        row-key="id"
        :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column align="center" label="序号" width="95">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (page - 1) * page_size + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="id" label="ID" width="100"> </el-table-column>
        <el-table-column label="所属园区" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.park">{{ scope.row.park.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="楼宇名称">
          <template slot-scope="scope">
            <div class="line2">{{ scope.row.name }}</div>
          </template>
        </el-table-column>
        <el-table-column label="楼宇类型" align="center">
          <template slot-scope="scope">
            <span
              v-for="(item, index) in scope.row.house_type_lists"
              :key="index"
            >
              <span v-if="index != 0">，</span> {{ item.title }}
            </span>
          </template>
        </el-table-column>

        <el-table-column label="租赁总面积（㎡）" align="center">
          <template slot-scope="scope">
            {{ scope.row.total_meters }}
          </template>
        </el-table-column>
        <el-table-column label="出租房总数" align="center">
          <template slot-scope="scope">
            {{ scope.row.house_total }}
          </template>
        </el-table-column>
        <el-table-column label="出租率" align="center" min-width="180">
          <template slot-scope="scope"> {{ scope.row.hire_rate }}% </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="created_at"
          label="操作"
          width="220"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="success"
              @click="edit(scope.row)"
              v-if="roles.includes('/space/edit')"
              >编辑</el-button
            >
            <el-button
              size="mini"
              type="warning"
              @click="toDetails(scope.row.id)"
              v-if="roles.includes('/space/info')"
              >详情</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="del(scope.row)"
              v-if="roles.includes('/space/del')"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[15, 30, 50]"
        :page-size="page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="margin-top: 10px"
      >
      </el-pagination>
      <el-dialog
        title="导入文件"
        :visible.sync="leadInVisible"
        @close="dialogClos"
      >
        <el-upload
          ref="upload"
          class="upload-demo"
          :action="baseURL + '/space/import'"
          :headers="{ token: token }"
          drag
          :limit="1"
          :on-success="handleAvatarSuccess"
          :on-progress="beforeAvatarUpload"
          :multiple="false"
          accept=".xlsx,.xls"
        >
          <!-- accept=".xlsx,.xls" -->
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">只能上传xlsx文件</div>
          <!-- ，且不超过500kb -->
        </el-upload>
        <el-progress
          v-if="progressFlag"
          :percentage="loadProgress"
        ></el-progress>
        <div class="error" v-if="msgData.length > 0">
          <div v-for="(item, index) in msgData" :key="index">{{ item }}</div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="leadInVisible = false">取 消</el-button>
          <el-button type="primary" @click="leadInVisible = false"
            >确 定</el-button
          >
        </div>
      </el-dialog>
      <el-dialog
        @opened="openDrawer"
        :close-on-click-modal="false"
        :title="spaceTitle"
        :visible.sync="spaceVisible"
        width="600px"
      >
        <el-form
          :model="spaceForm"
          :rules="spaceRules"
          ref="spaceForm"
          label-width="80px"
          class="demo-ruleForm"
        >
          <el-form-item label="所属园区" prop="park_id">
            <el-select
              filterable
              :disabled="spaceType != 'add'"
              v-model="spaceForm.park_id"
              placeholder="请选择园区"
              @change="formPark"
            >
              <el-option
                :label="item.name"
                :value="item.id"
                v-for="(item, index) in parkList"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="楼宇名称" prop="name">
            <el-input
              v-model="spaceForm.name"
              :disabled="spaceType == 'see'"
              placeholder="请输入楼宇名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="建筑面积" prop="total_meters">
            <el-input
              v-model="spaceForm.total_meters"
              :disabled="spaceType == 'see'"
              placeholder="请输入建筑面积"
            >
              <template slot="append">m²</template>
            </el-input>
          </el-form-item>
          <el-form-item label="楼层数" prop="floor">
            <el-input
              :disabled="spaceType != 'add'"
              v-model="spaceForm.floor"
              placeholder="请输入楼层数"
            ></el-input>
          </el-form-item>
          <el-form-item label="楼宇类型" prop="house_type_ids">
            <el-select
              filterable
              v-model="spaceForm.house_type_ids"
              placeholder="请选择楼宇类型"
              multiple
              collapse-tags
            >
              <el-option
                :label="item.title"
                :value="item.id"
                v-for="(item, index) in houseType"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input
              type="textarea"
              v-model="spaceForm.remark"
              :disabled="spaceType == 'see'"
              placeholder="请输入备注"
            ></el-input>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button @click="spaceVisible = false">取 消</el-button>
          <el-button v-if="spaceType == 'add'" type="primary" @click="append"
            >确 定</el-button
          >
          <el-button v-if="spaceType == 'edit'" type="primary" @click="redact"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
    <transition name="fade-transform" mode="out-in">
      <router-view :key="key" />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { pinyin } from "pinyin-pro";
import { infoAgo, openPark, transfer } from "@/api/index";
import {
  equipmentLists,
  getFacilityTypeList,
  getEquipmentTypeList,
  addEquipment,
  seeEquipment,
  editEquipment,
  delEquipment,
  templatetEquipment,
} from "@/api/facility";
import {
  spaceExport,
  getSpaceList,
  addSpace,
  editSpace,
  seeSpace,
  openHouseTypeLists,
  delSpace,
  spaceTemplate,
} from "@/api/space";
import { getToken } from "@/utils/auth";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl"]),
    key() {
      return this.$route.path;
    },
  },
  data() {
    return {
      options: [],
      cztype: "",
      drawerTitle: "",
      statusList: [
        {
          name: "请选择",
          value: "0",
        },
        {
          name: "天",
          value: "1",
        },
        {
          name: "周",
          value: "2",
        },
        {
          name: "月",
          value: "3",
        },
        {
          name: "季",
          value: "4",
        },
        {
          name: "年",
          value: "5",
        },
      ],
      logDrawer: false,
      logList: [],
      token: getToken(),
      list: [],
      total: 0,
      page: 1,
      page_size: 15,
      screen: {
        park_id: "",
        name: "",
        is_page: 1,
      },

      parkList: [],
      drawer: false,
      ruleForm: {},
      spaceForm: {},
      rules: {
        name: [
          {
            required: true,
            message: "请输入设备名称",
            trigger: "blur",
          },
        ],
        park_id: [
          {
            required: true,
            message: "请选择所属园区",
          },
        ],
        facility_ids: [
          {
            required: true,
            message: "请选择所属设施",
          },
        ],
        facility_equipment_type_ids: [
          {
            required: true,
            message: "请选择设备类型",
          },
        ],
        status: [
          {
            required: true,
            message: "请选择设备状态",
          },
        ],
      },
      spaceRules: {
        name: [
          {
            required: true,
            message: "请输入楼栋名称",
            trigger: "blur",
          },
        ],
        park_id: [
          {
            required: true,
            message: "请选择所属园区",
          },
        ],
        total_meters: [
          {
            required: true,
            message: "请输入建筑面积",
          },
        ],
        floor: [
          {
            required: true,
            message: "请输入楼层数",
          },
        ],
        house_type_ids: [
          {
            required: true,
            message: "请选择设楼宇类型",
          },
        ],
      },
      disabled: false,
      status: 0,
      EToptions: [],
      FToptions: [],
      leadInVisible: false,
      baseURL: this.$store.state.baseURL,
      loadProgress: 0,
      msgData: [],
      progressFlag: false,
      spaceVisible: false,
      spaceTitle: "",
      spaceType: "",
      houseType: [],
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
    } else {
      this.screen.park_id = "";
    }
    this.getPark();
    this.fetchData();
  },
  methods: {
    dialogClos() {
      this.msgData = [];
      this.$refs.upload.clearFiles();
    },
    toDetails(id) {
      this.$router.push({
        path: "/space/index/details",
        query: { spaceId: id },
      });
    },
    openDrawer() {
      this.$refs.spaceForm.clearValidate();
    },
    // 上传成功
    handleAvatarSuccess(res, file) {
      if (res.code === 200) {
        this.$message({
          message: res.msg,
          type: "success",
          duration: "1000",
          onClose: () => {
            //onClose是message消息框消失后要执行的回调
            //此处写提示关闭后需要执行的函数
          },
        });

        this.$refs.upload.clearFiles();

        this.leadInVisible = false;
      } else {
        this.$refs.upload.clearFiles();
        this.msgData = res.data;
        this.$message({
          message: res.msg,
          type: "error",
          duration: "1000",
        });
      }
      this.fetchData();
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },
    // 上传进度
    beforeAvatarUpload(event, file, fileList) {
      this.progressFlag = true;
      this.loadProgress = Math.floor(event.percent);
      let loadProgress = Math.floor(event.percent); //这就是当前上传的进度
      //可以进行其他逻辑
      if (loadProgress == 100) {
        this.progressFlag = false;
      }
    },
    // 导出
    derive() {
      let data = {
        park_id: this.screen.park_id,
        name: this.screen.name,
      };
      const loading = this.$loading({
          lock: true,
          text: '数据量过大，正在导出中...',
          spinner: 'el-icon-loading'
        });
      spaceExport(data).then((res) => {
        loading.close();
        let blob = new Blob([res.data], {
          type: "application/vnd.ms-excel;charset=utf-8",
        });
        let downloadElement = document.createElement("a");
        let href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        downloadElement.download = res.name;
        // downloadElement.target="_blank"
        downloadElement.setAttribute("target", "_blank");
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
      }).catch(error =>{
        loading.close();
      });
    },
    // 导入
    leadIn() {
      this.leadInVisible = true;
    },
    // 下载模板
    downloadFile() {
      spaceTemplate().then((res) => {
        if (res.code == 200) {
          window.open(res.data.download_url, "_self");
        }
      });
    },
    // 删除
    del(val) {
      var that = this;
      const data = {
        id: val.id,
      };
      this.$confirm("确认删除？")
        .then((_) => {
          delSpace(data).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch((_) => {});
    },
    // 编辑
    edit(val) {
      this.spaceType = "edit";
      this.spaceTitle = "编辑楼栋";
      this.formPark(val.park_id);
      setTimeout(() => {
        this.getInfo(val.id);
      }, 500);
      // this.drawer = true;
    },
    // 查看
    see(val) {
      this.cztype = "see";
      this.ruleForm.park_id = val.park_id;
      this.drawerTitle = "查看";
      setTimeout(() => {
        this.getInfo(val.id);
      }, 500);
      // this.ruleForm = val
      // this.drawer = true;
    },
    // 获取信息
    getInfo(id) {
      var that = this;
      seeSpace({ id: id }).then((res) => {
        this.spaceForm = {
          id: res.data.info.id,
          name: res.data.info.name,
          park_id: res.data.info.park_id,
          total_meters: res.data.info.total_meters,
          floor: res.data.info.floor,
          house_type_ids: [],
          remark: res.data.info.remark,
        };
        res.data.info.house_type_lists.forEach((element) => {
          this.spaceForm.house_type_ids.push(element.house_type_id);
        });
        // this.domains = res.data.company_role_data
      });
      this.spaceVisible = true;
    },
    ChangePark() {
      // this.getFTList(0);
    },
    changeName(e) {
      var that = this;
      const nameList = pinyin(this.ruleForm.name, {
        pattern: "first",
        toneType: "none",
        type: "array",
      })
        .join("")
        .toUpperCase();
      that.ruleForm.name_acronyms = nameList;
      if (that.ruleForm.pid == 0) {
        // var parkName = ''
        // this.treeData[0].children.forEach((item,index)=>{
        //   if(that.treeId == item.id){
        //     return parkName = item.name
        //   }
        // })
        // const park = pinyin(parkName,{ pattern: 'first', toneType: 'none', type: 'array' }).join('').toUpperCase()
        that.ruleForm.code = nameList;
      } else {
        that.ruleForm.code = that.oldCode + "-" + nameList;
      }
    },

    formPark(e) {
      let data = {
        park_id: e,
        status: 1,
      };
      openHouseTypeLists(data).then((res) => {
        this.houseType = res.data.lists.data;
      });
    },
    addSpace() {
      this.spaceTitle = "添加楼栋";
      this.spaceType = "add";
      this.spaceForm = {
        name: "",
        park_id: "",
        total_meters: "",
        floor: "",
        house_type_ids: [],
        remark: "",
      };
      this.spaceVisible = true;
    },
    addMenu() {
      this.drawerTitle = "添加设备";
      this.cztype = "add";
      this.ruleForm = {
        name: "",
        park_id: "",
        facility_ids: "",
        facility_equipment_type_ids: "",
        status: 1,
        specification: "",
        self_code: "",
        install_times: "",
        quality_guarantee_times: "",
        description: "",
      };
      this.getETList();
      this.drawer = true;
    },
    chongZhi() {
      this.screen = {
        park_id: "",
        name: "",
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
    },

    handleSizeChange(val) {
      this.page_size = val;
      this.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.fetchData();
    },
    handleCloses(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          done();
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
        })
        .catch(() => {});
    },
    // 获取园区
    getPark() {
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    // 编辑
    editForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.facility_id =
            this.ruleForm.facility_ids[this.ruleForm.facility_ids.length - 1];
          this.ruleForm.facility_equipment_type_id =
            this.ruleForm.facility_equipment_type_ids[
              this.ruleForm.facility_equipment_type_ids.length - 1
            ];
          this.ruleForm.install_time = this.ruleForm.install_times / 1000;
          this.ruleForm.quality_guarantee_time =
            this.ruleForm.quality_guarantee_times / 1000;
          editEquipment(this.ruleForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.fetchData();
              this.drawer = false;
            }
          });
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    redact() {
      var that = this;
      this.$refs.spaceForm.validate((valid) => {
        if (valid) {
          this.spaceForm.house_type_id =
            this.spaceForm.house_type_ids.toString(",");
          editSpace(this.spaceForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.fetchData();
              this.spaceVisible = false;
            }
          });
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    append() {
      var that = this;
      this.$refs.spaceForm.validate((valid) => {
        if (valid) {
          this.spaceForm.house_type_id =
            this.spaceForm.house_type_ids.toString(",");
          addSpace(this.spaceForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.fetchData();
              this.spaceVisible = false;
            }
          });
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 添加
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.facility_id = this.ruleForm.facility_ids.join();
          this.ruleForm.facility_equipment_type_id =
            this.ruleForm.facility_equipment_type_ids.join();
          this.ruleForm.install_time = this.ruleForm.install_times / 1000;
          this.ruleForm.quality_guarantee_time =
            this.ruleForm.quality_guarantee_times / 1000;
          addEquipment(this.ruleForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.fetchData();
              this.drawer = false;
            }
          });
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      this.screen.page = this.page;
      this.screen.page_size = this.page_size;
      getSpaceList(this.screen).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding: 0 20px;
  overflow: auto;
}
.table-box {
  margin-top: 20px;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.searchs {
  ::v-deep .el-form-item__label {
    opacity: 0 !important;
    display: block;
  }
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
::v-deep .screen {
  padding: 0 50px;
  .el-input {
    width: 200px;
  }
  .el-form--inline .el-form-item {
    width: 23%;
  }
}
.card {
  .des-box {
    p {
      padding: 0 10px;
      &.reason {
        color: #ff3300;
      }
    }
  }
}
::v-deep .el-message {
  width: 100px !important;
  height: 10px;
}
.upload-demo {
  ::v-deep .el-upload {
    width: 100%;
    .el-upload-dragger {
      width: 100%;
    }
  }
}

.error {
  width: 100%;
  max-height: 100px;
  overflow: auto;
  padding: 10px;
  border: 1px solid;
  color: red;
  div {
    line-height: 20px;
  }
}
</style>
